import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import reDirectTo from '../../assets/images/redirectToImg.svg'
import { useNavigate } from 'react-router-dom';
import PaginationComponent from '../PaginationComponent';
import noDataFound from '../../assets/images/no-data-found.svg'
import Skeleton from 'react-loading-skeleton';
import moment from 'moment-timezone';
import { formatDate } from '../DateTimeUtils';

const data = [
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Licence Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Customer Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Licence Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Customer Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Licence Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Customer Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Licence Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Customer Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Licence Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
    {
        timeStamp: '7/16/2024, 4:05:37 PM',
        user: 'John Doe',
        modules: 'Customer Management',
        action: 'Create Item',
        details: 'ID: 100, Name: Karthik, Description: Description Name ',
        reDirectTo: '',
    },
];

// const columns = [
//     { id: 'timeStamp', label: 'TIMESTAMP', align: 'left', minWidth: '150px' },
//     { id: 'user', label: 'USER', align: 'left', minWidth: '180px' },
//     { id: 'modules', label: 'MODULES', align: 'left', minWidth: '150px' },
//     { id: 'action', label: 'ACTION', align: 'left', minWidth: '200px' },
//     { id: 'details', label: 'DETAILS', align: 'left', minWidth: '150px' },
//     { id: 'reDirectTo', label: 'RE-DIRECT TO', align: 'left', minWidth: '200px' },
// ];

const columns = [
    { id: 'Date', label: 'TIME STAMP', align: 'left', minWidth: '200px' },
    { id: 'UpdatedBy', label: 'USER', align: 'left', minWidth: '150px' },
    { id: 'ModuleName', label: 'MODULES', align: 'left', minWidth: '200px' },
    // { id: 'ActivityLogID', label: 'ACTIVITY LOG ID', align: 'left', minWidth: '180px' },
    { id: 'Type', label: 'ACTIVITY TYPE', align: 'left', minWidth: '180px' },
    { id: 'Description', label: 'DESCRIPTION', align: 'left', minWidth: '350px' },
    // { id: 'UpdatedByID', label: 'UPDATED BY ID', align: 'left', minWidth: '200px' },
    // { id: 'ISTDate', label: 'IST DATE', align: 'left', minWidth: '200px' },
    { id: 'reDirectTo', label: 'RE-DIRECT TO', align: 'left', minWidth: '200px' },
];

const AuditTrialTable = ({ getAuditTrialData, loading, page, rowsPerPage, setRowsPerPage, setPage, totalDataCount }) => {

    const navigate = useNavigate(); // Initialize navigate
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    // Pagination state
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = getAuditTrialData.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [getAuditTrialData, order, orderBy]);

    const handleReDirect = (modules) => {
        if (modules === 'Licence Management') {
            navigate('/usermanagement');
        } else if (modules === 'Customer Management') {
            navigate('/customermanagement');
        } else {
            console.log('Unknown module:', modules);
        }
    };

    // Pagination logic
    useEffect(() => {
        if (!getAuditTrialData || getAuditTrialData.length === 0) {
            console.warn("⚠️ No Audit Trial Data Found!");
            setPaginatedData([]);
            return;
        }

        // Sort data based on order & orderBy
        const sorted = [...getAuditTrialData].sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            return a[orderBy] < b[orderBy] ? -1 * orderModifier : 1 * orderModifier;
        });

        // Calculate pagination
        const maxPage = Math.ceil(sorted.length / rowsPerPage);
        const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

        const start = newPage * rowsPerPage;
        const end = start + rowsPerPage;
        const paginated = sorted.slice(start, end);

        setPaginatedData(paginated);
    }, [getAuditTrialData, order, orderBy, page, rowsPerPage]);


    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };


    return (
        <>
            <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                        {column.label}
                                        {column.sortable !== false && (
                                            <IconButton
                                                size="small"
                                                onClick={(event) => handleRequestSort(event, column.id)}
                                            >
                                                <img src={SortIcon} alt="Sort" />
                                            </IconButton>
                                        )}
                                    </div>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            loading ? (
                                [...Array(rowsPerPage)].map((_, index) => (
                                    <TableRow key={index}>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align}>
                                                <Skeleton height={40} />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : paginatedData.length === 0 ? (
                                // Display "No Data Found" row if no data is present in the paginated data
                                <TableRow>
                                    <TableCell colSpan={columns.length} align="center">
                                        <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                paginatedData.map((customer) => (
                                    <TableRow key={customer.id}>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align}>
                                                {column.id === 'reDirectTo' ? (
                                                    <img src={reDirectTo} alt='Assign To' className='assignTo-img' onClick={() => handleReDirect(customer.modules)} />
                                                ) : column.id === 'Date' ? (
                                                    formatDate(customer[column.id]) // Format the Date field
                                                ) : (
                                                    customer[column.id] || "NA"
                                                )}
                                            </TableCell>

                                        ))}
                                    </TableRow>
                                )))}
                    </TableBody>
                </Table>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                >
                    <MenuItem onClick={() => handleSortOrderChange('asc')}>
                        <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                        Ascending to Descending
                    </MenuItem>
                    <MenuItem onClick={() => handleSortOrderChange('desc')}>
                        <img src={descToAsc} alt="" />&nbsp;&nbsp;
                        Descending to Ascending
                    </MenuItem>
                </Menu>
            </TableContainer>
            {/* Use PaginationComponent */}
            <PaginationComponent
                totalItems={totalDataCount}
                itemsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </>
    );
};

export default AuditTrialTable;
